module.exports = __webpack_public_path__ + "static/media/corporative.0dda77d4.png";